import i18n from '@/plugins/i18n';

export const getOrdersTableHeaders = (
  permissions,
  showOrganization) => {
  return [
    {
      text: i18n.t('table.header.status'),
      value: 'orderStatus',
      width: 90
    },
    {
      text: i18n.t('table.header.order.number'),
      value: 'orderNumber',
      width: 100
    },
    {
      text: i18n.t('table.header.organization'),
      value: 'organizationId',
      width: 150,
      isHidden: !showOrganization
    },
    {
      text: i18n.t('table.header.user'),
      value: 'owner.lastName',
      width: 100,
    },
    {
      text: i18n.t('table.header.source'),
      value: 'dataSource',
      width: 100
    },
    {
      text: i18n.t('table.header.create.date'),
      value: 'orderCreateDateTime',
      width: 150
    },
    {
      text: i18n.t('table.header.price'),
      value: 'orderPrice',
      width: 100,
      isHidden: permissions.hasHidePrices
    },
    {
      text: i18n.t('table.header.actions'),
      value: 'actions',
      width: 100,
      align: 'end',
      sortable: false
    },
    { text: '', width: 50, value: 'data-table-expand' }
  ].filter((header) => {
    return !header.isHidden
  });
};
